// 接口
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'
// 配方
export const getFTresult = (data) => axios.get(baseUrl + '/queapi/robot_writing/formula/backword?' + data)

// 工艺包
export const getGyresult = (data) => axios.post(baseUrl + '/pfapi/package', data)

// 获取下控参数
export const getXKvaluedata = (data) => axios.post(baseUrl + '/pfapi/sinter', data)
// 根据选中设备获取设备数据趋势
export const getwarlist = (data) => axios.get(baseUrl + '/wapi/cm/cm_warn/page?' + data)

// 获取白草莓温度数据
export const gettempdata = () => axios.get(baseUrl + '/wapi/cm/cm_humi_avg')

//获取设备列表
export const getsblist = () => axios.get(baseUrl + '/wapi/cm/cm_switch')

//更改设备列表
export const setsbstatus = (data) => axios.put(baseUrl + '/wapi/cm/cm_switch?' + data)

// 获取下控参数
export const setXiakong = (data) => axios.post(baseUrl + '/pfapi/sinter_control', data)

// 获取实际参数
export const getrealXkdetail = () => axios.post(baseUrl + '/pfapi/sinter_read')
    
// 获取实际参数
export const getbcmsblist = (data) => axios.get(baseUrl + '/wapi/cm/device_type/list?type=' + data)

// 获取实际参数
export const getsbdatalist = (data) => axios.get(baseUrl + '/pcapi/cm/30min_new?' + data)

// 获取实际参数
export const getweatherdata = () => axios.get(baseUrl + '/wapi/city/real')

// 获取报告
export const getreport = (data) => axios.post(baseUrl + '/reportapi/get_report', data)

// 根据id获取设备当前状态
export const getsbstatusbyid = (data) => axios.get(baseUrl + '/wapi/cm/cm_device_status?' + data)
    
 // 操控设备
export const setsbstatusbyid = (data) => axios.get(baseUrl + '/wapi/cm/cm_device_open_close?' + data)   
 // 获取设备状态
export const getsbonlinestatus = () => axios.get(baseUrl + '/sapi/get_status')   

// 获取大棚列表
export const getGreenhouseList = () => axios.post(baseUrl + '/pcapi/api/basic/greenhouse/selection', { enableStatus: 1 })

// 根据大棚ID获取设备类型列表
export const getDeviceClassifyList = (greenhouseId) => axios.post(baseUrl + '/pcapi/api/data-center/data-trend/device-classify-list', { greenhouseId })

// 获取视频监控列表
export const getMonitorList = (params = {page: 1, pageSize: 100}) => axios.post(baseUrl + '/pcapi/api/monitor/list-page', params)

// 获取用户绑定的大棚列表
export const getUserGreenhouseList = () => axios.post(baseUrl + '/pcapi/api/basic/greenhouse/selection', { enableStatus: 1 })   
    









